/* eslint-disable no-console */

export default function saveRecentInventoryCreator(userDuck, personalization) {
  return _ref => {
    let {
      id
    } = _ref;
    return async dispatch => {
      try {
        const now = new Date();

        // attempt to update local storage when it's considered as a "new" search
        const {
          items
        } = personalization.addInventory({
          id,
          timestamp: now.getTime()
        });
        dispatch(userDuck.creators.setRecentInventory(items));
      } catch (error) {
        console.log(error);
      }
    };
  };
}